import { EnumBadge } from '@mxa-argos/components/custom/enum-badge';
import { SearchItemLayout } from '@mxa-argos/modules/search/components/search-item-layout';
import type { SearchResult } from '@mxa-argos/modules/search/hooks/use-resource-search';
import { Replace } from 'lucide-react';

interface Props {
  result: SearchResult;
}

export function ChangeSearchItem({ result }: Props) {
  return (
    <SearchItemLayout
      icon={Replace}
      primary={result.primary}
      secondary={
        result.secondary && <EnumBadge enumName="ChangeStatus" value={result.secondary} size="sm" />
      }
      tertiary={result.tertiary && <span className="font-mono">{result.tertiary}</span>}
      quaternary={result.quaternary && <span className="font-mono">{result.quaternary}</span>}
    />
  );
}
